import React, { useState } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ClipLoader } from "react-spinners";
import {
  completeAccountSetupStep1,
  completeAccountSetupStep2,
} from "../../../redux/action/auth";

function CompleteAccountSetup() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.account);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const emailSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const passwordSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain an uppercase letter")
      .matches(/[a-z]/, "Password must contain a lowercase letter")
      .matches(/[0-9]/, "Password must contain a number")
      .matches(/[!@#$%^&*]/, "Password must contain a special character (!@#$%^&*)"),
    confirmPassword: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("newPassword")], "Password mismatch"),
  });

  return (
    <div className="auth-from" style={{ width: "850px" }}>
      <div className="valign-wrapper justify-center column full-width">
        <div className="flex justify-center">
          <img src="/images/auction-image.png" alt="logo" className="auction-logo" />
        </div>

        <h4 className="margin-0px text-center">Complete your account Setup</h4>

        <div className="full-width">
          <Formik
            initialValues={{ email: "" }}
            validationSchema={emailSchema}
            onSubmit={({ email }) => {
              dispatch(completeAccountSetupStep1(email));
            }}
          >
            {({ isValid, dirty }) => (
              <Form className="mt-1">
                <div className="input-field-style">
                  <span className="material-symbols-outlined primary">email</span>
                  <Field
                    className="browser-default"
                    name="email"
                    type="email"
                    placeholder="Enter your Email Id"
                  />
                  <button className="btn" type="submit" disabled={!isValid || !dirty || loading}>
                    {loading ? <ClipLoader color="#fff" size={15} /> : "Verify"}
                  </button>
                </div>
                <ErrorMessage name="email" component="div" className="error-message red-text" />
              </Form>
            )}
          </Formik>

          <Formik
            initialValues={{ newPassword: "", confirmPassword: "" }}
            validationSchema={passwordSchema}
            onSubmit={({ newPassword, confirmPassword }) => {
              dispatch(completeAccountSetupStep2(newPassword, confirmPassword));
            }}
          >
            {({ isValid, dirty }) => (
              <Form className="mt-1">
                <div className="input-field-style">
                  <span className="material-symbols-outlined primary">lock</span>
                  <Field
                    className="browser-default input-field"
                    type={showPassword ? "text" : "password"}
                    name="newPassword"
                    placeholder="Enter your password"
                  />
                  <div
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ width: "25px" }}
                  >
                    {showPassword ? (
                      <AiFillEye className="eye-icon" />
                    ) : (
                      <AiFillEyeInvisible className="eye-icon" />
                    )}
                  </div>
                </div>
                <ErrorMessage name="newPassword" component="div" className="error-message red-text" />
                <div className="input-field-style">
                  <span className="material-symbols-outlined primary">lock</span>
                  <Field
                    className="browser-default input-field"
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Enter your Confirm password"
                  />
                  <div
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{ width: "25px" }}
                  >
                    {showConfirmPassword ? (
                      <AiFillEye className="eye-icon" />
                    ) : (
                      <AiFillEyeInvisible className="eye-icon" />
                    )}
                  </div>
                </div>
                <ErrorMessage name="confirmPassword" component="div" className="error-message red-text" />

                <div className="submit-btn mv-2 column flex align-center">
                  <button
                    className="btn full-width mb-1 mt-1"
                    type="submit"
                    disabled={!isValid || !dirty || loading}
                  >
                    {loading ? <ClipLoader color="#fff" size={20} /> : "Submit"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default CompleteAccountSetup;




// import React, { useState } from "react";
// import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
// import { useDispatch, useSelector } from "react-redux";

// import { ClipLoader } from "react-spinners";
// import { notifyError } from "../../../helpers/helpers";
// import {
//   completeAccountSetupStep1,
//   completeAccountSetupStep2,
// } from "../../../redux/action/auth";

// function CompleteAccountSetup() {
//   const dispatch = useDispatch();
//   const { loading } = useSelector((state) => state.account);
//   const [email, setEmail] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");

//   const updatePassword = (e) => {
//     e.preventDefault();
//     if (newPassword !== confirmPassword) {
//       return notifyError("Password and confirm password do not match");
//     }
//     if (newPassword.length < 8) {
//       return notifyError("Password should be at least 8 characters long");
//     }
//     if (!/[A-Z]/.test(newPassword)) {
//       return notifyError("Password should contain at least one uppercase letter");
//     }
//     if (!/[a-z]/.test(newPassword)) {
//       return notifyError("Password should contain at least one lowercase letter");
//     }
//     if (!/[0-9]/.test(newPassword)) {
//       return notifyError("Password should contain at least one number (0-9)");
//     }
//     if (!/[!@#$%^&*]/.test(newPassword)) {
//       return notifyError("Password should contain at least one special character ! @ # $ % ^ & *");
//     }

//     // dispatch(completeAccountSetupStep2(newPassword, confirmPassword));
//   };

//   const verifyEmail = (e) => {
//     e.preventDefault();
//     dispatch(completeAccountSetupStep1(email));
//   };

//   return (
//     <div className="auth-from " style={{ width: "850px" }}>
//       <div className="valign-wrapper justify-center column full-width">
//         <div className="flex justify-center ">
//           <img
//             src="/images/auction-image.png"
//             alt="logo"
//             className="auction-logo"
//           />
//         </div>

//         <h4 className="margin-0px text-center">Complete your account Setup</h4>

//         <div className="full-width">
//           <form className="mt-1" onSubmit={verifyEmail}>
//             <div className="input-field-style">
//               <span className="material-symbols-outlined primary">email</span>
//               <input
//                 className="browser-default "
//                 placeholder="Enter your Email Id"
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//               />
//               <button
//                 className="btn"
//                 disabled={!email || loading}
//                 type="submit"
//               >
//                 {loading ? <ClipLoader color="#fff" size={15} /> : "Verify"}
//               </button>
//             </div>
//           </form>
//           <form className="mt-1" onSubmit={updatePassword}>
//             <div className="input-field-style">
//               <span className="material-symbols-outlined primary ">lock</span>
//               <input
//                 className="browser-default input-field "
//                 placeholder="Enter your password"
//                 type={showPassword ? "text" : "password"}
//                 onChange={(e) => setNewPassword(e.target.value)}
//                 required
//                 value={newPassword}
//               />
//               <div
//                 onClick={() => {
//                   setShowPassword(!showPassword);
//                 }}
//                 style={{ width: "25px" }}
//               >
//                 {showPassword ? (
//                   <AiFillEye className="eye-icon" />
//                 ) : (
//                   <AiFillEyeInvisible className="eye-icon" />
//                 )}
//               </div>
//             </div>
//             <div className="input-field-style">
//               <span className="material-symbols-outlined primary ">lock</span>
//               <input
//                 className="browser-default input-field "
//                 placeholder="Enter your Confirm password"
//                 type={showConfirmPassword ? "text" : "password"}
//                 onChange={(e) => setConfirmPassword(e.target.value)}
//                 required
//               />
//               <div
//                 onClick={() => {
//                   setShowConfirmPassword(!showConfirmPassword);
//                 }}
//                 style={{ width: "25px" }}
//               >
//                 {showConfirmPassword ? (
//                   <AiFillEye className="eye-icon" />
//                 ) : (
//                   <AiFillEyeInvisible className="eye-icon" />
//                 )}
//               </div>
//             </div>

//             <div className="submit-btn mv-2 column flex align-center ">
//               <button
//                 className="btn full-width mb-1 mt-1 "
//                 type="submit"
//                 disabled={!newPassword || !confirmPassword || loading}
//               >
//                 {loading ? <ClipLoader color="#fff" size={20} /> : "Submit"}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default CompleteAccountSetup;
